<template>
    <template-content-view>
        <template #left>
            <div class="caption d-none d-sm-block">
                {{ $tr("Мониторинг") }}
            </div>
        </template>
        <template #right>
            <v-btn v-for="item in intervals" :key="item.value" :variant="item.value == interval ? 'tonal': 'text'"
                @click="interval = item.value">
                {{ item.title }}</v-btn>
        </template>
        <template #content>
            <v-container class="bg-background">
                <v-row no-gutters>
                    <v-col v-for="(chat, index) in chats" :key="index">
                        <chat-view class="pa-1 ma-1" :data="chat" :options="options"></chat-view>
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </template-content-view>
</template>

<script>
import TemplateContentView from '@topomatic/tap/src/components/TemplateContentView.vue';
import Utils from '@topomatic/tap/src/utils';
import ChatView from './ChatView.vue';

export default {
    name: 'MonitoringView',
    components: {
        TemplateContentView,
        ChatView,
    },
    data() {
        return {
            data: {
                monitoring: [],
            },
            options: {
                responsive: true,
            },
            interval: 10,
            intervals: [
                {
                    title: '10m',
                    value: 10,
                },
                {
                    title: '1h',
                    value: 60,
                },
                {
                    title: '3h',
                    value: 180,
                },
                {
                    title: '1d',
                    value: 60 * 24,
                },
                {
                    title: '1w',
                    value: 60 * 24 * 7,
                },
                {
                    title: '1mo',
                    value: 60 * 24 * 30,
                },
            ],
        };
    },
    computed: {
        chats() {
            return [
                this.getChatData('avg', this.$tr('Средняя нагрузка'), '#f87979'),
                this.getChatData('top', this.$tr('Максимальная нагрузка'), '#007979'),
                this.getChatData('ws', this.$tr('Подключения'), '#f87900'),
                this.getChatData('n', this.$tr('Размер'), '#5B9A8B', this.$tr('Б')),
                this.getChatData('files', this.$tr('Файлов'), '#EBE76C'),
                this.getChatData('folders', this.$tr('Папок'), '#F0B86E'),
                this.getChatData('rev', this.$tr('Ревизии'), '#836096'),
                this.getChatData('tmp', this.$tr('Временное хранилище'), '#58D68D', this.$tr('Б')),
                this.getChatData('ntmp', this.$tr('Файлов во временном хранилище'), '#2E86C1'),
            ];
        },
    },
    methods: {
        fetchData() {
            this.$api.getMonitoring().then((data) => {
                this.data = data;
            });
        },
        getChatData(field, label, color, units) {
            const values = [];
            const labels = [];
            const monitoring = this.data.monitoring;
            const interval = this.interval;
            let clabel = units == null ? label : `${label}, ${units}`;
            let format;
            switch (interval) {
            case 10:
                format = 'HH:mm';
                break;
            case 60:
            case 180:
                format = 'DD MMM HH:mm';
                break;
            case 60 * 24:
            case 60 * 24 * 7:
                format = 'DD MMM';
                break;
            case 60 * 24 * 30:
                format = 'MMM YYYY';
                break;
            default:
                format = 'DD.MM.YY, HH:mm';
                break;
            }
            if (monitoring.length > 0) {
                let now = Utils.parseDate(monitoring[monitoring.length - 1].date);
                let idx = monitoring.length - 1;
                let value = null;
                while (idx >= 0) {
                    const item = monitoring[idx];
                    const date = Utils.parseDate(item.date);
                    const delta = now.diff(date, 'minutes', true);
                    if (delta >= interval) {
                        labels.unshift(now.format(format));
                        values.unshift(value);
                        value = null;
                        now = now.subtract(interval, 'minutes');
                        if (labels.length >= 36) {
                            break;
                        }
                    } else {
                        if (value == null) {
                            value = item[field] || null;
                        } else {
                            value = Math.max(value, item[field] || null);
                        }
                        idx -= 1;
                    }
                }
                if (value != null) {
                    labels.unshift(now.format(format));
                    values.unshift(value);
                }
                let mv = 0;
                for (let i = 0; i < values.length; i += 1) {
                    if (values[i] != null) {
                        mv = Math.max(mv, values[i]);
                    }
                }
                const prefixes = ['', this.$tr('К'), this.$tr('М'), this.$tr('Г'), this.$tr('Т'), this.$tr('П'), this.$tr('Э')];
                let sidx = 0;
                let scale = 1.0;
                while (mv > 4096.0) {
                    mv /= 1000.0;
                    scale *= 1000;
                    sidx += 1;
                }
                if (sidx > 0) {
                    for (let i = 0; i < values.length; i += 1) {
                        values[i] = Math.round((values[i] / scale) * 100.0) / 100.0;
                        clabel = `${label}, ${prefixes[sidx]}${units || ''}`;
                    }
                }
            }
            const data = {
                labels,
                datasets: [
                    {
                        label: clabel,
                        backgroundColor: color,
                        data: values,
                    },
                ],
            };
            return data;
        },
    },
    created() {
        this.fetchData();
    },
    mounted() {
        this.timer = setInterval(() => {
            this.fetchData();
        }, 10 * 60 * 1000);
    },
    unmounted() {
        clearInterval(this.timer);
    },
};
</script>

<style scoped>
.caption {
    font-size: 1.75rem;
    align-self: center;
    padding-left: 16px;
}
</style>
